// extracted by mini-css-extract-plugin
export default {"section":"HandClassificationDataSection_section__xNEVU","left":"HandClassificationDataSection_left__2tBO5","right":"HandClassificationDataSection_right__Msxy2"};